import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';


/** Import any ng-zorro components as the module required except icon module */
import { NzButtonModule} from 'ng-zorro-antd/button';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { ResourceDetailComponent } from './resource-detail.component';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzSpinModule } from 'ng-zorro-antd/spin';


/** Assign all ng-zorro modules to this array*/
const antdModule = [
    NzButtonModule,
    NzCardModule,
    NzTableModule,
    NzAvatarModule, 
    NzPopoverModule,
    NzCheckboxModule,
    NzTagModule,
    NzBadgeModule,
    NzEmptyModule,
    NzSpinModule,

]

@NgModule({
    imports: [
        SharedModule,
        ...antdModule
    ],
    exports: [],
    declarations: [
        ResourceDetailComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ResourceDetailModule { }
